import { actionTypeVentilstilling } from "../actions/ventilstillingerActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const initialState = {};
const ventilstillingReducer = (state = initialState, action) =>
  CreateNewReducer(state, action, actionTypeVentilstilling);

export default ventilstillingReducer;
